import { ToastContainer, toast } from "react-toastify";

import AuthForm from "../../../components/AuthForm";

import { getAuthToken } from "../../../auth/auth";
import { API_BASE_URL } from "../../../config";
import { useActionData, useNavigation } from "react-router-dom";
import { useEffect } from "react";

export default function ForgotPasswordAdmin() {
  const actionData = useActionData();
  const navigation = useNavigation();

  const isSubmitting = navigation.state === "submitting";

  useEffect(() => {
    if (actionData?.success) {
      toast.success(actionData?.message);
    }

    if (actionData?.error) {
      toast.error(actionData?.message);
    }
  }, [actionData]);

  console.log("action data", actionData);
  const fields = [
    {
      label: "Email",
      type: "email",
      placeholder: "example@email.com",
      name: "email",
    },
  ];
  return (
    <section id="login_register">
      <ToastContainer position="top-right" autoClose={3000} />
      <AuthForm
        method="POST"
        title="Forgot Password"
        fields={fields}
        buttonText={isSubmitting ? "Reseting Password..." : "Reset Password"}
      ></AuthForm>
    </section>
  );
}

export const forgotPasswordAction = async ({ request }) => {
  const formData = await request.formData();
  const token = getAuthToken();

  const data = {
    email: formData.get("email"),
  };

  const response = await fetch(`${API_BASE_URL}/admin/forgot-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();
  console.log(result);

  if (result.success === false) {
    return {
      error: result.message || "There was an error. Please try again",
    };
  }

  return { success: true, message: result.message };
};
